export default defineAppConfig({
  toaster: {
    position: "top-right" as const,
    expand: true,
    duration: 5000,
    // Ensure proper encoding for toast messages
    encoding: "utf-8",
  },
  theme: {
    radius: 0.25,
    blackAsPrimary: false,
  },
  ui: {
    colors: {
      primary: "orange",
      secondary: "purple",
      neutral: "zinc",
    },
    fonts: {
      sans: ["Inter", "ui-sans-serif", "system-ui", "sans-serif"],
      mono: ["ui-monospace", "SFMono-Regular", "Consolas", "monospace"],
    },
  },
  compilerOptions: {
    isCustomElement: (tag: string) => ["sidebar"].includes(tag),
  },
  locale: {
    encoding: "utf-8",
  },
});
